'use client'

import { cn } from "@/lib/utils";
import { Tag } from "@prisma/client";
import { X } from "lucide-react";
import { useState } from "react";
import { Badge } from "./ui/badge";
import { Label } from "./ui/label";


const TagBadge = ({ tag, canRemove = false, onRemove, className }: { tag: Tag, canRemove?: boolean, onRemove?: (tagId: string) => void, className?: string }) => {
      const [isHovered, setIsHovered] = useState(false);

      return (
            <Badge variant="outline"
                  className={cn("relative min-w-[80px] rounded-full", className)}
                  style={{ backgroundColor: tag.backgroundColor || "transparent", color: tag.foregroundColor || "black" }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}>
                  {isHovered && canRemove && (
                        <div
                              className="absolute w-full h-full flex items-center justify-center transition-transform duration-300 ease-in-out hover:rotate-90"
                              onClick={() => onRemove?.(tag.id)}
                        >
                              <X className="size-6 cursor-pointer" />
                        </div>
                  )}
                  <Label className={cn(isHovered && canRemove && "invisible")}>{tag.label}</Label>
            </Badge>
      )
}

export default TagBadge;
